import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PlaceNormalTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeNormalTrade(req);
    }
}
export default PlaceNormalTradeUseCase;
